import morphdom from "morphdom"
import { buildOptions } from "web-ui/morphdom/build-options"

function morph() {
  const options = buildOptions({
    childrenOnly: this.hasAttribute("children-only")
  })

  this.targetElements.forEach(targetElement => {
    const fromElement = targetElement
    let toElement

    if (options.childrenOnly) {
      toElement = this.templateContent
    } else {
      toElement = this.templateElement.innerHTML
    }

    morphdom(fromElement, toElement, options)
  })
}

export function activate(Turbo) {
  Turbo.StreamActions.morph = morph
}
